class Accordeon {
    constructor(domElements) {
        this.domElements = domElements;
        this.#init();
        //console.log(this);
    }
    #init() {
        this.#addEventListeners()
    }

    #addEventListeners() {

        const selectors = [
            '.faq-row__counter', 
            '.faq-row__icon',
            '.faq-row__title',
        ];

        this.domElements.forEach(el => {
            if (el.inited) {
                return;
            }
            el.inited = true;

            
            selectors.forEach(sel => {
                const element = el.querySelector(sel);

                if (!element) {
                    return;
                }

                element.addEventListener('click', () => {
                    //console.log('click');
                    this.#contentHide(el);
                });
            });
        });
    }

    #contentHide(element) {
        element.classList.toggle('faq-row--open');
    }

}

const initAccordions = () => {
    const accordeons = document.querySelectorAll('.faq-row');
    new Accordeon(accordeons);
};

(() => {
    initAccordions();
})();

export default initAccordions;
